/**
 * Ids for the contacts bulk actions that are not a contact field.
 *
 * A field setter is identified by the field it writes (`leadStatus`,
 * `utmSource`), so it needs no id of its own; these do something else
 * entirely, and the double underscore keeps them out of that namespace. They
 * live here rather than beside the hook that builds them because other tables
 * offer a subset of the same actions (see the treatment table) and reach for
 * these ids to say which, which should not mean importing a hook.
 */
export const TAGS_ACTION_ID = `__tags`
export const PIPELINE_ACTION_ID = `__pipeline`
export const TASK_ACTION_ID = `__task`
export const SMS_ACTION_ID = `__sms`
export const WORKFLOW_ACTION_ID = `__workflow`
export const NON_PATIENT_ACTION_ID = `__nonPatient`
export const REMOVE_FROM_LIST_ACTION_ID = `__removeFromList`
